import EventPackageCreate from './EventPackageCreate'
import EventPackageEdit from './EventPackageEdit'
import EventPackageList from './EventPackageList'

const EventPackageIndex = {
  list: EventPackageList,
  edit: EventPackageEdit,
  create: EventPackageCreate,
}

export default EventPackageIndex
